import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import * as moment from 'moment';

import {PrescriptionMedicines} from '../models/prescription-medicines.model';

@Injectable()
export class PrescriptionMedsAdapter
  implements IAdapter<PrescriptionMedicines>
{
  adaptToModel(resp: any): PrescriptionMedicines {
    if (resp.medicines && resp.medicines.length > 0) {
      resp.medicines.forEach(med => {
        med.time = moment(
          med.timeToTake,
          moment.HTML5_FMT.TIME_SECONDS,
        ).toDate();
      });
    }
    return resp;
  }
  adaptFromModel(data: PrescriptionMedicines): any {
    if (data.time && !isNaN(data.time.getTime())) {
      data.timeToTake = moment(data.time).format(moment.HTML5_FMT.TIME_SECONDS);
      delete data.time;
    } else if (data.time && isNaN(data.time.getTime())) {
      delete data.timeToTake;
      delete data.time;
    } else {
      // Do nothing
    }

    if (data.location) {
      delete data.location;
    }
    if (data.foodRestrictionLabel) {
      delete data.foodRestrictionLabel;
    }
    if (data.restrictionImg) {
      delete data.restrictionImg;
    }
    return data;
  }
}
